module.exports = __webpack_public_path__ + "img/schaumverfahren.ca6feb1.png";